import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6} onClick={() => {window.scrollTo(0,0)}}>
            <span className="signature">Daksh</span>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/dakshgupta1511/"><img src={navIcon1} alt="LinkedIn" /></a>
              <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/dakshgupta1511"><img src={navIcon2} alt="Twitter" /></a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dakshgupta2002/"><img src={navIcon3} alt="Instagram" /></a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
